var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovedbadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347",
    transform: "translate(-1316 -145)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1316 145)",
    fill: "#01b762"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bx-box",
    transform: "translate(1322.902 151.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M14.775,3H3.419A1.419,1.419,0,0,0,2,4.419V5.839A1.419,1.419,0,0,0,2.71,7.06v7.3a1.419,1.419,0,0,0,1.419,1.419h9.936a1.419,1.419,0,0,0,1.419-1.419V7.06a1.419,1.419,0,0,0,.71-1.221V4.419A1.419,1.419,0,0,0,14.775,3ZM3.419,4.419H14.775V5.839H3.419Zm.71,9.936v-7.1h9.936v7.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bx-check",
    d: "M6.7,9.766l-.982-.982-.422.422,1.4,1.4,2.9-2.9L9.17,7.293Z",
    transform: "translate(1324.558 153.421)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedbadge);
export default __webpack_public_path__ + "static/media/Approved badge.299d08c3a9537036256b4b7be10df2ff.svg";
export { ForwardRef as ReactComponent };